module.exports = {
    "collectionLabel": `\xd6neriler`
};


//# sourceMappingURL=tr-TR.main.js.map
